import { render, staticRenderFns } from "./HeaderWithTitle.vue?vue&type=template&id=2361e7df"
import script from "./HeaderWithTitle.vue?vue&type=script&lang=js"
export * from "./HeaderWithTitle.vue?vue&type=script&lang=js"
import style0 from "./HeaderWithTitle.vue?vue&type=style&index=0&id=2361e7df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCountDown: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCountDown.vue').default,TlmChip: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmChip.vue').default,ProductBrandAndTitle: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/BrandAndTitle.vue').default})
